// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b_aYDvk1VFoIRXjxUZCy {
  height: calc(100vh - 75px);
  overflow: hidden;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/views/DashboardV2/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,0BAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AADF","sourcesContent":["$header_height: 75px;\n\n.wrapper {\n  height: calc(100vh - #{$header_height});\n  overflow: hidden;\n  padding-bottom: 40px;\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `b_aYDvk1VFoIRXjxUZCy`
};
export default ___CSS_LOADER_EXPORT___;
